import { render, staticRenderFns } from "./PremiumLinkGenerator.vue?vue&type=template&id=384759bd&scoped=true&"
import script from "./PremiumLinkGenerator.vue?vue&type=script&lang=js&"
export * from "./PremiumLinkGenerator.vue?vue&type=script&lang=js&"
import style0 from "./PremiumLinkGenerator.vue?vue&type=style&index=0&id=384759bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384759bd",
  null
  
)

export default component.exports